import React from 'react';
import { Link } from 'react-router-dom';

const allCities = [
  { name: 'Mexico City', path: '/relocation/cdmx' },
  { name: 'Mérida', path: '/relocation/merida' },
  { name: 'Tulum', path: '/relocation/tulum' },
  { name: 'San Miguel de Allende', path: '/relocation/san-miguel-de-allende' },
  { name: 'Puerto Vallarta', path: '/relocation/puerto-vallarta' },
  { name: 'Playa del Carmen', path: '/relocation/playa-del-carmen' },
];

const RelocationBreadcrumb = ({ cityName }) => (
  <nav className="text-sm text-[#888] mb-6" aria-label="Breadcrumb" data-testid="breadcrumb">
    <Link to="/" className="hover:text-[#FFFFFF] transition">Home</Link>
    <span className="mx-2">/</span>
    <Link to="/relocation" className="hover:text-[#FFFFFF] transition">Relocation</Link>
    {cityName && (
      <>
        <span className="mx-2">/</span>
        <span className="text-[#FFFFFF]">{cityName}</span>
      </>
    )}
  </nav>
);

const RelocationSiblingLinks = ({ currentPath }) => {
  const siblings = allCities.filter((c) => c.path !== currentPath);
  return (
    <section className="py-12 border-t border-[#e0dbd4] bg-[#FAF7F2]">
      <div className="max-w-4xl mx-auto px-6 lg:px-12 text-center">
        <p className="text-[#888] text-sm mb-3">Also considering:</p>
        <div className="flex flex-wrap justify-center gap-x-4 gap-y-2">
          {siblings.map((c) => (
            <Link key={c.path} to={c.path} className="text-sm text-[#666] hover:text-[#E8A830] transition">
              {c.name}
            </Link>
          ))}
        </div>
        <Link to="/relocation" className="inline-block mt-4 text-xs text-[#888] hover:text-[#FFFFFF] transition">
          ← Back to all cities
        </Link>
      </div>
    </section>
  );
};

export { RelocationBreadcrumb, RelocationSiblingLinks, allCities };
